import { Injectable } from '@angular/core';
import { FilterService } from './filter.service';
import { ContactsQuery } from '../../../models/contacts-query';

@Injectable({
  providedIn: 'root'
})
export class ContactFilterService extends FilterService<ContactsQuery> {}
